<button class="ui basic button" (click)="onLogout()">Log out</button>
